import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';

import { Helmet, StaticContext, ErrorCard, FourOhFourError, TabletScreen } from '@sm/webassets';
import { getClientEnvironmentDetails } from '@sm/utils';

import NavBar from '../../components/NavBar';
import SearchBox from '../../components/SearchBox';
import AppListingList from '../../components/AppListingList';
import AppListingSkeleton from '../../components/AppListingList/AppListingSkeleton';
import AppDirectoryBasePage from '../AppDirectoryBasePage';

import { publishedApplicationListingCategory } from './listings.graphql';

const CATEGORIES_FETCH_LIMIT = 50;

const Categories = ({ match }) => {
  const {
    environment: { languageId, subdomain, tld },
    userAgent,
  } = useContext(StaticContext);
  const { isDesktop } = getClientEnvironmentDetails(userAgent);
  const { categoryKey } = match.params;
  return (
    <AppDirectoryBasePage
      id={`App Directory - Categories ${categoryKey}`}
      pageMetricsAttributes={{ categoryKey }}
      navbar={
        <>
          <TabletScreen defaultMatches={isDesktop}>
            <div className="wds-m-b-4">
              <SearchBox location="categories" />
            </div>
          </TabletScreen>
          <NavBar />
        </>
      }
    >
      <Query
        query={publishedApplicationListingCategory}
        variables={{
          subdomain,
          tld,
          language: languageId,
          categoryKey: match.params.categoryKey,
          page: 1,
          pageSize: CATEGORIES_FETCH_LIMIT,
        }}
      >
        {({ loading, error, data }) => {
          return (
            <Choose>
              <When condition={error}>
                <ErrorCard />
              </When>
              <When condition={loading}>
                <AppListingSkeleton data-testid="Categories__Skeleton" />
              </When>
              <When condition={data && data.publishedApplicationListingCategory === null}>
                <FourOhFourError />
              </When>
              <Otherwise>
                <Helmet>
                  <title>{`SurveyMonkey ${data.publishedApplicationListingCategory.name} Apps and Integrations`}</title>
                  <meta
                    name="description"
                    content={`Integrate with SurveyMonkey ${data.publishedApplicationListingCategory.name} apps and plug-ins to get more done`}
                  />
                </Helmet>
                <AppListingList
                  title={data.publishedApplicationListingCategory.name}
                  apps={data.publishedApplicationListingCategory.publishedApplicationListings.items}
                />
              </Otherwise>
            </Choose>
          );
        }}
      </Query>
    </AppDirectoryBasePage>
  );
};

Categories.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      categoryKey: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default Categories;
